module.exports = __webpack_public_path__ + "static/media/coffeeIcon.71e980b3.svg";